import { render, staticRenderFns } from "./SpotlightSearch.vue?vue&type=template&id=210a0982&scoped=true"
import script from "./SpotlightSearch.vue?vue&type=script&lang=js"
export * from "./SpotlightSearch.vue?vue&type=script&lang=js"
import style0 from "./SpotlightSearch.vue?vue&type=style&index=0&id=210a0982&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210a0982",
  null
  
)

export default component.exports